import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainLayoutComponent } from './components/main-layout/main-layout.component';
import { RouterModule } from '@angular/router';
import { ModuleLoaderModule } from '../common/module-loader/module-loader.module';
import { ComponentLoader } from '../core/component-loader/component-loader.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ModuleLoaderModule,
    ComponentLoader
  ],
  declarations: [MainLayoutComponent],
  exports: [MainLayoutComponent],
})
export class LayoutsModule { }
